export { SectionCard } from '@/shared/ui/components/basic/section-card/SectionCard';
export { InfoRow } from '@/shared/ui/components/basic/section-card/InfoRow';
import { formatLocalizedDate } from '@/shared/utils/date';
import PersonAvatar from '@/features/client-management/components/ClientAvatar';
import { getClientAvatarAccentColor } from '@/features/client-management/utils/avatar-accent';

interface AvatarProps {
  name: string | undefined;
}

/**
 * Circular avatar for the visit's client, matching the clients list/table pattern.
 */
export function ClientAvatar({ name }: AvatarProps) {
  return <PersonAvatar fullName={name ?? '--'} size={40} accentColor={getClientAvatarAccentColor(name)} />;
}

/**
 * Circular avatar for the visit's broker, matching the clients list/table pattern.
 */
export function BrokerAvatar({ name }: AvatarProps) {
  return <PersonAvatar fullName={name ?? '--'} size={40} accentColor={getClientAvatarAccentColor(name)} />;
}

/**
 * Format an ISO date string (YYYY-MM-DD) as a localized date, or an em dash when empty.
 */
export function formatDateFull(iso: string): string {
  if (!iso) return '—';
  return formatLocalizedDate(iso) || '—';
}
